/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recent_Sales_TitleInputs */

const fr_recent_sales_title = /** @type {(inputs: Recent_Sales_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventes récentes`)
};

/**

* @param {Recent_Sales_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const recent_sales_title = /** @type {((inputs?: Recent_Sales_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_Sales_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_recent_sales_title(inputs)
});